import React from "react";
import classNames from "classnames";
import { useUiContext } from "@rotorstudios/fe-ui";

import LayoutSection from "../../uiLayouts/LayoutSection/LayoutSection";
import LayoutContainer from "../../uiLayouts/LayoutContainer/LayoutContainer";
import LayoutGrid from "../../uiLayouts/LayoutGrid/LayoutGrid";
import LayoutColumn from "../../uiLayouts/LayoutColumn/LayoutColumn";
import VehicleFilter from "./components/VehicleFilter";
import VehicleCardsGrid from "./components/VehicleCardsGrid";
import useUiMVehicleSelector from "./useUIMVehicleSelector";

import "./_UiMVehicleSelector.scss";

type UiMVehicleSelectorProps = {
  customClassName?: string;
  onClose: () => void;
};

const UiMVehicleSelector: React.FC<UiMVehicleSelectorProps> = ({
  customClassName = "",
  onClose,
}) => {
  const { projectClass, breakpointActive, isMobile } = useUiContext();
  const {
    vehicleFilters,
    filteredCards,
    selectedFilter,
    handleFilterChange,
    handleSelectVehicle,
  } = useUiMVehicleSelector(onClose);

  const getClassName = () =>
    classNames(`${projectClass}_UiMVehicleSelector`, breakpointActive, customClassName);

  return (
    <LayoutSection customClassName={getClassName()}>
      <LayoutContainer>
        <LayoutGrid columns={"2-1-3"} gap={2}>
          <LayoutColumn>
            <LayoutContainer
              customClassName={`${projectClass}_UiMVehicleSelector__filter`}
            >
              <VehicleFilter
                filters={vehicleFilters ?? []}
                onFilterChange={handleFilterChange}
                selectedFilter={selectedFilter}
              />
            </LayoutContainer>
          </LayoutColumn>
          {isMobile && <div className="divider" />}
          <LayoutColumn customClassName="divider-left">
            <LayoutContainer
              customClassName={`${projectClass}_UiMVehicleSelector__results`}
            >
              <VehicleCardsGrid
                vehicleCards={filteredCards}
                onButtonClick={handleSelectVehicle}
              />
            </LayoutContainer>
          </LayoutColumn>
        </LayoutGrid>
      </LayoutContainer>
    </LayoutSection>
  );
};

export default UiMVehicleSelector;
